import(/* webpackMode: "eager" */ "/home/runner/work/Seedmancer-web/Seedmancer-web/next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/Seedmancer-web/Seedmancer-web/next/src/components/landing/Header.tsx");
